import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import { Text3 } from "~/components/typographies/Texts";
import { TentangKamiCompoCounter } from "./TentangKamiCompoCounter";

export const TentangKamiCompoQuickProof = () => {
  const quickProof = [
    {
      id: 1,
      counter: 14,
      imageQuickProof:
        "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-di-bekasi_icon-1a.png",
      titleQuickProof: "Tahun",
      descriptQuickProof: "Kami telah berpengalaman sejak tahun 2010.",
    },
    {
      id: 2,
      counter: 24,
      imageQuickProof:
        "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-di-bekasi_icon-2.png",
      titleQuickProof: "Spesialis",
      descriptQuickProof: "Memberikan layanan dengan profesional.",
    },
    {
      id: 3,
      counter: 500,
      imageQuickProof:
        "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-di-bekasi_icon-3.png",
      titleQuickProof: "Klien",
      descriptQuickProof: "Telah menyelesaikan ratusan project klien.",
    },
  ];

  return (
    <>
      <div className={`mt-[2rem] px-0 w-full  z-10`}>
        <div
          className={
            "bg-theme-secondary text-black w-full pt-[1rem] pb-[1.5rem] px-[1.3rem] lg:py-[2rem] grid grid-cols-1 lg:grid-cols-3 gap-y-[2rem] shadow-md rounded-lg"
          }
        >
          {quickProof?.map((item) => {
            return (
              <div className="flex flex-row gap-2" key={item.id}>
                <div className="flex flex-row gap-[1.5rem] items-center">
                  <div className="p-[0.5rem] max-w-[4rem] max-h-[4rem] ">
                    <img
                      className="-mt-[1rem] max-w-[4rem] max-h-[4rem] image-item rounded-lg"
                      src={item.imageQuickProof}
                      alt="Background"
                    />
                  </div>
                  <div className="flex flex-row items-center gap-2">
                    <div className="flex flex-col">
                      <div className="flex flex-row gap-1 items-center">
                        <span
                          className={twMerge(
                            clsx(``, "text-4xl font-bold line-clamp-1")
                          )}
                        >
                          +
                        </span>
                        <TentangKamiCompoCounter
                          value={item.counter}
                          //   interval={"medium"}
                        />
                        <span
                          className={twMerge(
                            clsx(``, "text-2xl font-bold line-clamp-1")
                          )}
                        >
                          {item.titleQuickProof}
                        </span>
                      </div>

                      <Text3
                        className={twMerge(clsx(``, "line-clamp-2"))}
                        text={item.descriptQuickProof}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
